const CARDID_MATCH = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
const PHONE_MATCH = /^[1][3,4,5,7,8][0-9]{9}$/
const TEL_MATCH = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/
// const PHONE_TEN_MATCH = /^[1][3,4,5,6,7,8,9][0-9]{9}$|^(\\(\\d{3,4}-)|\\d{3,4}-\\)?\\d{7,8}$/
const PSD_MATCH =  /^[a-zA-Z]([-_a-zA-Z0-9]{5,17})$/ // 密码：以字母开头，长度在6-18之间，只能包含字母、数字和下划线
const USERNAME_MATCH = /^[a-zA-Z]([-_a-zA-Z0-9]{4,15})$/ // 账号：以字母开头，长度在5-16之间，只能包含字母、数字和下划线
// 验证账号
export function userNameVali(rule, value, callback) {
  if (USERNAME_MATCH.test(value)) {
    callback();
  } else {
    callback('请输入正确格式用户名');
  }
}
// 验证密码
export function psdVali(rule, value, callback) {
  if (PSD_MATCH.test(value)) {
    callback();
  } else {
    callback('请输入正确格式密码');
  }
}
// 验证手机号+固定电话
export function phonesValidate(telNumber) {
  if (PHONE_MATCH.test(telNumber) || TEL_MATCH.test(telNumber)) {
    return true
  } else {
    return false
  }
}
// 验证手机号
export function phoneValidate(phoneNumber) {
  if (PHONE_MATCH.test(phoneNumber)) {
    return true
  } else {
    return false
  }
}
export function phoneVali(rule, value, callback) {
  if (PHONE_MATCH.test(value)) {
    callback();
  } else {
    callback('请输入正确手机号码');
  }
}
// 验证身份证
export function cardIdValidate(cardId) {
  if (CARDID_MATCH.test(cardId)) {
    return true
  } else {
    return false
  }
}
export function cardIdVali(rule, value, callback) {
  if (CARDID_MATCH.test(value)) {
    callback();
  } else {
    callback('请输入正确身份证号码');
  }
}
// location.search转对象
export function urlSearchToOb(str) {
  if (str === '') return
  str = str.substr(1)
  let arr = str.split("&")
  let obj = {}
  let newArr = []
  arr.map(function(value, index, arr) {
    newArr = value.split("=")
    if (newArr[0] !== undefined) {
      obj[newArr[0]] = newArr[1]
    }
  })
  return obj
}
// 截流函数 函数柯里化
export function debounce(func, delay) {
    let timer
    return function (...args) {
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(() => {
            func.apply(this, args)
        }, delay)
    }
}
// 年月日格式转换 yyyy-MM-dd-hh-mm-ss
export function formatDate(date, fmt) {
  var date = new Date(date)
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}
function padLeftZero(str) {
    return ('00' + str).substr(str.length)
}

export function copy(data) {
  let copyData = JSON.stringify(data)
  copyData = JSON.parse(copyData)
  return copyData
}

// 深拷贝
export function copyDeep(obj1) {
  var obj2 = Array.isArray(obj1) ? [] : {}
  if (obj1 && typeof obj1 === 'object') {
    for (var i in obj1) {
      var prop = obj1[i] // 避免相互引用造成死循环，如obj1.a=obj
      if (prop == obj1) {
        continue
      }
      if (obj1.hasOwnProperty(i)) {
        // 如果子属性为引用数据类型，递归复制
        if (prop && typeof prop === 'object') {
          obj2[i] = copy(prop) // 递归调用
        } else {
          // 如果是基本数据类型，只是简单的复制
          obj2[i] = prop
        }
      }
    }
  } else {
    obj2 = null
  }
  return obj2
}
// 查字典——放进formDes的options/format中
export function formDesDyn(infoFormTitle, prop, res) {
  // console.log('prop', prop)
  if (Array.isArray(infoFormTitle)) {
    var typeProp = infoFormTitle.find((e, i, arr) => {
      if (typeof e == 'object') {
        return e.prop == prop
      } else {
        return e == prop
      }
    })
  } else {
    var typeProp = infoFormTitle
  }
  // console.log('infoFormTitle', copy(infoFormTitle))
  // console.log('typeProp', typeProp)
  // console.log('typeProp', res.data.itemList)
  typeProp.options = []
  res.data.itemList.forEach((e, i, arr) => {
    // console.log(e)
    typeProp.options.push({
      id: e.id,
      label: e.label || e.itemName,
      data: (e.data || e.itemValue) + '',
      sortNo: e.sortNo || ''
    })
  })
  // console.log('infoFormTitle1', copy(infoFormTitle))
  typeProp.format = function(data) {
    // console.log('1111', data, prop, res)
    let item = res.data.itemList.find((e, i, arr) => {
      return (data == e.data || data == e.itemValue)
    })
    return item && (item.label || item.itemName)  || ''
  }
  // console.log('infoFormTitle',infoFormTitle)
  // if (prop == 'idType') {
    // console.log('typeProp', typeProp)
  // }
  // return newTypeProp
}

// 地址回显
export function showAddress(itemData) {
  itemData.areaIdList = []
  if (itemData.provinceId && itemData.provinceId !== -1) {
    itemData.areaIdList.push(itemData.provinceId)
  }
  if (itemData.cityId && itemData.cityId !== -1) {
    itemData.areaIdList.push(itemData.cityId)
  }
  if (itemData.districtId && itemData.districtId !== -1) {
    itemData.areaIdList.push(itemData.districtId)
  }
}

// 一份Data中取出指定data重新组成data
export function getNewData(data, needArr) {
  var newData = {}
  needArr.forEach((e) => {
    // console.log('typeof', e, typeof data[e])
    if (typeof data[e] != 'undefined') {
      newData[e] = data[e] == null ? '' : data[e]
      // console.log('newData[e]', typeof newData[e])
    }
  })
  return newData
}
// 导出excel表格
export function getExcel(fileName, labelL, keyL, dataL) {
  let data = formatJson(keyL, dataL)
  export_json_to_excel(labelL, data, fileName)
}

function formatJson(filterVal, jsonData) {
  return jsonData.map(v => filterVal.map(j => v[j]))
}

// 打平多层嵌套数组
export function aPing(arr) {
  var res = [] // 最终输出容器
  var c = 0 // 过程中取到的值放在这，之后push进res
  for(let i=0; i<arr.length; i++) {
    c = arr[i]
    if (Array.isArray(c.childrenList)) {
      c = aPing(c.childrenList)
      res.push.apply(res, c)
    } else {
      res.push(c)
    }
  }
  return res
}

export function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}



// WEBPACK FOOTER //
// ./src/common/js/util.js